import { useEffect, useRef, useState } from "react";

import { addIdealModelsHook, addIdealModelsHookOnce, type OnIdeal } from "@doitintl/models-any";

export const useIsHeadless = () => {
  const [isHeadless, setIsHeadless] = useState<boolean>();

  useEffect(() => {
    const userAgent = navigator.userAgent || "";
    setIsHeadless(userAgent.includes("HeadlessChrome"));
  }, []);

  return isHeadless;
};

const useModelsIdeal = (
  name: string,
  interval: number,
  onIdeal: OnIdeal,
  addHookFn: (name: string, interval: number, onIdeal: OnIdeal) => void,
  condition: boolean
) => {
  const isHeadless = useIsHeadless();
  const onIdealRef = useRef<OnIdeal>(onIdeal);

  useEffect(() => {
    if (!condition) {
      return;
    }

    if (isHeadless === true || isHeadless === undefined) {
      return;
    }

    addHookFn(name, interval, onIdealRef.current);
  }, [isHeadless, name, interval, onIdeal, addHookFn, condition]);
};

// Specific hooks
export const useModelsIdealHook = (name: string, interval: number, onIdeal: OnIdeal, condition = true) => {
  useModelsIdeal(name, interval, onIdeal, addIdealModelsHook, condition);
};

export const useModelsIdealHookOnce = (name: string, interval: number, onIdeal: OnIdeal, condition = true) => {
  useModelsIdeal(name, interval, onIdeal, addIdealModelsHookOnce, condition);
};
